import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { EnvironmentUrls } from '@vision/ui/env';
import { ENV } from '@vision/ui/utils';
import { SupportedLanguages } from '@vision/ui/interfaces';
import { DEFAULT_LANG } from '@vision/ui/i18n';

export function useEnvironmentUrl(key: keyof EnvironmentUrls) {
  const { i18n } = useTranslation();

  return useMemo(() => {
    const lang = i18n.language as SupportedLanguages;
    const collection = ENV.URLS[lang];
    return collection?.[key] || ENV.URLS[DEFAULT_LANG][key];
  }, [i18n.language, key]);
}
